import Client from '@/lib/axios';

const axios = Client();

export const patchClientStatus = async ({ id, status }) =>
  axios.patch(`/clients/${id}`, { status });

export const getClient = id => axios.get(`/users/${id}/profile`);
